import * as yup from "yup";

export const adsManagementSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  description: yup.string().required("Description is required"),
  image: yup.string().required("Image is required"),
  loyalty_points: yup.number(),
});
